import { gozokiApiWithAuth } from '../gozokiApi'

export interface RealEstateEventResponse {
  id: string
  storeProjectId: string | null
  storeProjectName: string | null
  title: string
  description: string
  startDate: string
  endDate: string | null
  allDay: boolean
  startTime: string | null
  endTime: string | null
  createdBy: {
    id: string
    firstName: string
    lastName: string
  }
  createdAt: string
  updatedAt: string
}

export const fetchRealEstateEvents = async (): Promise<RealEstateEventResponse[]> => {
  const response = await gozokiApiWithAuth.get<RealEstateEventResponse[]>('/real-estate-events')
  return response.data
}
